import du from '../utils/dom-utilities';
import {lightboxTpl} from '../templates/lightboxTpl';

/**
 * Lightbox Class
 *
 * @export
 * @class Lightbox
 */
export class Lightbox {

    /**
     * Create an instance of lightbox.
     *
     * @param {string} id an optional id for the dom lightbox
     * @param {string} label an optional label for the close button
     * @memberOf Lightbox
     */
    constructor(id = 'lightbox', label='Fermer') {
        if (document.getElementById(id)) {
            console.error(`Element with id: "${id}" already exist on the DOM`);
        }
        document.querySelector('body').insertAdjacentHTML('beforeend', lightboxTpl(id, label));

        this.lightbox = document.getElementById(id);
        this.content = this.lightbox.querySelector('.js-lightbox-content');
        this.modifierCssClass = [];

        // Elements that trigger a closing of the lightbox.
        du.queryAll('.js-lightbox-close', this.lightbox)
            .forEach((elem)=>{
                du.onEvent(elem, 'click', (evt) => {
                    evt.preventDefault();
                    this.close();
                });
            });

        document.onkeydown = (evt) => {
            evt = evt || window.event;
            var isEscape = false;
            if ('key' in evt) {
                isEscape = (evt.key === 'Escape' || evt.key === 'Esc');
            } else {
                isEscape = (evt.keyCode === 27);
            }
            if (isEscape) {
                this.close();
            }
        };
    }

    /**
     * Function to close the lightbox
     *
     * @memberOf Lightbox
     */
    close() {
        du.setClass(this.lightbox, 'lightbox--off');
        du.unsetClass(document.querySelector('html'), 'documentScrollHidden');

        window.setTimeout(() => {
            this.content.innerHTML = '';

            du.unsetClass(this.lightbox, 'lightbox--on');
            du.unsetClass(this.lightbox, 'lightbox--off');

            if (this.modifierCssClass.length) {
                this.modifierCssClass.forEach((cssClass) => {
                    du.unsetClass(this.lightbox, cssClass);
                });
                this.modifierCssClass = [];
            }
        }, 200); // Time in milliseconds, synched to CSS animation.
    }

    /**
     * Function to open lightbox
     *
     * @param {Array} modifierCssClass Array of {string} css class for lightbox
     * @memberOf Lightbox
     */
    open(modifierCssClass = null) {
        if (Array.isArray(modifierCssClass)) {
            this.modifierCssClass = modifierCssClass;
            this.modifierCssClass.forEach((cssClass) => {
                du.setClass(this.lightbox, cssClass);
            });
        }
        du.setClass(document.querySelector('html'), 'documentScrollHidden');
        du.setClass(this.lightbox, 'lightbox--on');
    }

    /**
     * Insert html data string in content
     *
     * @param {string} data htmlstring to insert
     * @returns {HTMLElement} of content
     * @memberOf Lightbox
     */
    insertData(data) {
        this.content.innerHTML = data;
        return this.content;
    }

};



// WEBPACK FOOTER //
// ./src/main/js/components/lightbox.js